<template>
    <div class="success">

        <!-- 头部背景 -->
        <div class="success-bgc"></div>

        <!-- 表单区域 -->
        <div class="hang-from">

            <!-- 内容区域 -->
            <div class="from-content" ref="fromsave">

                <!-- logo区域 -->
                <div class="from-logo">
                    <img class="from-logo-icon" :src="baseUrl + pageview.pagelogo" alt="" />
                    <div class="from-logo-tex">
                        <h1 class="logo-tex-h1">{{ pageview.title }}</h1>
                        <span class="logo-tex-span">{{ pageview.subhead }}</span>
                    </div>
                </div>

                <!-- 表单区域 -->
                <div class="from-input">
                    <div class="from-input-item">
                        <div class="input-item-left">挂号科室：</div>
                        <div class="input-item-right">
                            {{ office }}
                        </div>
                    </div>
                    <div class="from-input-item">
                        <div class="input-item-left">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</div>
                        <div class="input-item-right">
                            {{ details.uname }}
                        </div>
                    </div>
                    <div class="from-input-item">
                        <div class="input-item-left">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</div>
                        <div class="input-item-right">
                            {{ details.sex }}
                        </div>
                    </div>
                    <div class="from-input-item">
                        <div class="input-item-left">年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;龄:</div>
                        <div class="input-item-right">
                            {{ details.age }}
                        </div>
                    </div>
                    <div class="from-input-item">
                        <div class="input-item-left">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话:</div>
                        <div class="input-item-right">
                            {{ details.telephone }}
                        </div>
                    </div>
                    <div class="from-input-item">
                        <div class="input-item-left">就诊日期:</div>
                        <div class="input-item-right">
                            {{ details.diagndata }}
                        </div>
                    </div>
                    <div class="from-input-item">
                        <div class="input-item-left">就诊时间:</div>
                        <div class="input-item-right">
                            {{ details.diagntime }}
                        </div>
                    </div>
                    <div class="from-input-item" style="margin-top: 50px;">
                        <div class="input-item-left">就诊编号:</div>
                        <div class="input-item-right">
                            {{ details.serialnum }}
                        </div>
                    </div>
                    <div class="from-input-item">
                        <div class="input-item-left">挂号状态:</div>
                        <div class="input-item-right">
                            {{ details.state }}
                        </div>
                    </div>
                </div>

                <!-- 注意事项 -->
                <div class="matters-need">
                    <span class="matters-need-title">挂号注意事项:</span>
                    {{ pageview.attention }}
                </div>

                <!-- 医院地理信息 -->
                <div class="matters-need">
                    <span class="matters-need-title">医院地址:</span>
                    {{ pageview.hosaddress }}
                </div>

                <!-- 水印印章 -->
                <div class="watermark-seal">
                    <img class="seal-icon" :src="baseUrl + pageview.stamp" alt="" srcset="">
                </div>

            </div>
            <!-- 返回上级 -->
            <div class="fanhui-shangji" @click="saveClick">
                保存并返回
            </div>
        </div>
    </div>
</template>

<script>
import config from "@/utils/config";
import { Toast } from "vant"
import { getPageviewApi, getRigDetailApi } from "@/api/reservaApi.js"
import html2canvas from 'html2canvas'
export default {
    data() {
        return {
            baseUrl: config.baseUrl,
            pageview: {},
            details: {
                "uname": "",
                "sex": "",
                "age": "",
                "telephone": "",
                "diagndata": "",
                "diagntime": "",
                "serialnum": "",
                "state": "",
            },
            office: "",
        }
    },
    created() {
        let id = this.$route.query.id
        this.getPageview()
        if (id != 0) this.getRigDetail(id)

    },
    methods: {
        // 获取配置信息
        getPageview() {
            getPageviewApi().then(res => {
                this.pageview = res.data
            })
        },
        // 预约详情
        getRigDetail(id) {
            getRigDetailApi({ id }).then(res => {
                this.office = res.data.office ? res.data.office.officename : ""
                this.details = res.data
            })
        },
        // 保存并返回
        async saveClick() {
            const dom = this.$refs.fromsave
            try {
                const canvas = await html2canvas(dom, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: '#fff',
                    logging: false,
                    windowWidth: dom.scrollWidth,
                    windowHeight: dom.scrollHeight,
                })
                // 转base64
                const imgUrl = canvas.toDataURL('image/png')
                // a标签下载
                const a = document.createElement('a')
                a.href = imgUrl
                a.download = '预约挂号.png'
                a.click()
                Toast('保存成功！');
                setTimeout(() => { this.$router.go(-1) }, 2000)
            } catch (err) {
                Toast('保存失败！');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.success {
    width: 100%;
    min-height: 100vh;
    background-color: #F1F1F1;

    .fanhui-shangji {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        background-color: #527966;
        font-size: 14px;
        text-align: center;
        color: #fff;
    }

    .hang-from {
        width: 100%;
        margin-top: -260px;
        height: auto;
        padding: 0 20px;
        padding-bottom: 20px;
        box-sizing: border-box;

        .from-content {
            width: 100%;
            height: auto;
            background-color: #fff;
            padding: 20px;
            border-radius: 5px;
            box-sizing: border-box;
            position: relative;

            .watermark-seal {
                position: absolute;
                left: 0;
                bottom: 80px;
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                height: auto;
                display: flex;
                flex-direction: row-reverse;
                z-index: 222;

                .seal-icon {
                    width: 120px;
                    height: 120px;
                }
            }

            .matters-need:last-of-type {
                margin-bottom: 5px !important;
            }

            .matters-need {
                width: 100%;
                font-size: 12px;
                color: #527966;
                text-align: justify;
                letter-spacing: 1px;
                margin-top: 20px;

                .matters-need-title {
                    font-size: 13px;
                    font-weight: bold;
                    color: #527966;
                }
            }

            .from-input {
                width: 100%;
                margin-top: 50px;

                .from-input-item {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;

                    .input-item-left {
                        width: 80px;
                        font-size: 15px;
                        color: #527966;
                        font-weight: 600;
                    }

                    .input-item-right {
                        flex: 1;
                        font-size: 14px;
                        color: #527966;
                    }
                }
            }

            .from-logo {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .from-logo-tex {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    margin-left: 20px;

                    .logo-tex-h1 {
                        text-align: right;
                        font-size: 20px;
                        color: #527966;
                        font-weight: 600;
                    }

                    .logo-tex-span {
                        text-align: right;
                        margin-top: 8px;
                        font-size: 16px;
                        color: #527966;
                        font-weight: 500;
                    }
                }

                .from-logo-icon {
                    width: 50px;
                    height: 45px;
                }
            }
        }
    }

    .success-bgc {
        width: 100%;
        height: 300px;
        background-color: #527966;
    }
}
</style>